function cashLifting() {

    let cashLiftingService = [
        {
            name: "Cash Lifting",
            icon: "Cash Lifting",
            logoName: "fee",
            // flag: "voucherRequired",
            displayService: "cashLifting",
            items: [],
        },
    ];

    const dashboard = () => {
        const dashboardArr = [
            {
                path: "/index/cash-Lifting",
                name: "Dashboard",
                icon: "dashboard",
                logoName: "dashboard",
                flag: "DASHBOARD",
            },
        ];

        return dashboardArr;
    };

    const CashLifting = () => {
        const profileArr = [
            {
                path: "/index/Cash-LiftingP",
                name: "Cash Lifting",
                icon: "fee-master",
                logoName: "cash_Lifting",
                flag: "CASH LIFTING",
            },
        ];
        return profileArr;
    };

    let a = dashboard();
    let b = CashLifting();

    cashLiftingService[0].items = [...a, ...b];

    return cashLiftingService;
}

export default cashLifting;